import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Maintenance = Loadable(lazy(() => import('./Maintenance')));

const MaintenanceRoutes = [
	{
		path: '/maintenance',
		element: <Maintenance />,
		auth: authRoles.admin,
	},
];

export default MaintenanceRoutes;
